
import { Component, Prop, Vue } from "vue-property-decorator";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiShieldLock, mdiCheck, mdiShieldRefreshOutline } from "@mdi/js";
import { Getter } from "vuex-class";

@Component({
  components: {
    SvgIcon,
  },
})
export default class PrimaryCodeManagement extends Vue {

  get headers() {
    return this.isMobile ?
      [
        { text: "Code", value: "code" },
      ]
      :
      [
        { text: "Date", value: "date" },
        { text: "Code Actif", value: "is_current_code" },
        { text: "Code", value: "code" },
      ];
  }

  @Prop()
  public boxId: number;

  @Getter private isMobile: boolean;

  private model = true;
  private codes = [];
  private loading = false;
  private codeVisible = false;
  private newCodeGenerated = false;

  private mdiShieldLock = mdiShieldLock;
  private mdiCheck = mdiCheck;
  private mdiShieldRefreshOutline = mdiShieldRefreshOutline;

  public cancel() {
    this.codeVisible = false;
    this.codes = [];
    this.$emit("cancel");
  }

  private async mounted(): Promise<void> {
    this.reset();
  }

  private reset(): void {
    this.loading = false;
    this.codes = [];
    this.codeVisible = false;
    this.newCodeGenerated = false;
    this.codes = [{
      created_at: new Date(),
      is_current_code: true,
      revealed_at: new Date(),
      synchronized_at: new Date(),
      code: "XXXXXXXX",
    }];
  }

  private async revealPrimaryCode(): Promise<void> {
    this.loading = true;
    this.newCodeGenerated = false;
    return this.$store.dispatch("boxes/getPrimaryCodes", {
      id: this.boxId,
    }).then((data) => {
      this.codeVisible = true;
      this.codes = data;
    }).finally(() => {
      this.loading = false;
    });

  }


  private async resetPrimaryCode(): Promise<void> {

    this.loading = true;
    return this.$store.dispatch("boxes/resetPrimaryCodes", {
      id: this.boxId,
    }).then((data) => {
      this.reset();
      this.newCodeGenerated = true;
    }).finally(() => {
      this.loading = false;
    });

  }

}
